import React from "react";
import Banner from "../img/cubess.png";
import Banners from "../img/cubeleft.png";
const Webimagefooter = () => {
  return (
    <div className="w-full md:mt-[-200px]  mt-[-250px] z-50 ">
      <img src={Banner} alt=""  className=" hidden md:block h-[250px] w-[250px] mt-[-60px]" />
      <img src={Banners} alt=""  className="md:hidden block " />
    </div>
  );
};

export default Webimagefooter;
